import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    PUT_RECENTLY_USED_PHYSICIANS_SUCCESS,
    PUT_RECENTLY_USED_PHYSICIANS_FAILURE,
} from '../actions';

export default function* putRecentlyUsedPhysicians(action) {
    const queryParams = yield select(
        (state) => state.surgeryReducer.surgeryDetails
    );
    const physicianIdToUse = action.payload || queryParams.physicianId;
    // physicianId can be a plain string OR an object
    // ({ physicianId, physicianDisplayName, ... }). Extract the inner id when
    // it's an object; never fall back to the object itself, otherwise the URL
    // serializes to "[object Object]" (e.g. EMEA text-physician with no id).
    const physicianIdValue =
        physicianIdToUse && typeof physicianIdToUse === 'object'
            ? physicianIdToUse.physicianId
            : physicianIdToUse;
    if (physicianIdValue && typeof physicianIdValue !== 'object') {
const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/physicians?filteredPhysicians=${
        physicianIdValue
    }`;
    try {
        const result = yield axios.put(url).then((response) => response.data);

        yield put({ type: PUT_RECENTLY_USED_PHYSICIANS_SUCCESS, data: result });
    } catch (e) {
        yield logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: queryParams || '',
        });
        yield put({
            type: PUT_RECENTLY_USED_PHYSICIANS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
    }    
}
